import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import PageNotFound404 from '~pages/404'
import { loadDefaultFonts } from '~/core/utils/fonts'
import { useSelector } from 'react-redux'
import { useDispatch } from '~editor/hooks/useDispatch'
import { getShard } from '~editor/selectors/shard'
import { NewShard } from '~core/NewShard'
import { usePenpal } from '~core/hooks/usePenpal'
import { eventEmitter, EventTypes } from '~editor/events'
import { DATA_ACTION_TYPES } from '@gameglass/shared'
import { GoToForgeEnum } from '~core/global.type'
import { logger } from '~core/logger/logger'

const Render = () => {
  const router = useRouter()
  const { clientMounted, goToForge, changeRoute } = usePenpal()
  const shard = useSelector(getShard)
  const [show404, setShow404] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    loadDefaultFonts()

    return () => {
      eventEmitter.emit(EventTypes.rtcSend, {
        type: DATA_ACTION_TYPES.unsubscribeData,
      })
    }
  }, [])

  useEffect(() => {
    if (typeof window !== 'undefined' && router.query.shardId) {
      const shardId: number | null =
        parseInt(
          Array.isArray(router.query.shardId)
            ? router.query.shardId[0]
            : router.query.shardId,
        ) || null

      if (shardId) {
        try {
          dispatch.shard
            .loadAsync({ id: shardId, prefetch: true })
            .then(() => clientMounted(true))
            .catch(() => goToForge(GoToForgeEnum.collection_shard_list))
          setShow404(false)
        } catch (error) {
          logger.error(error)
          setShow404(true)
          clientMounted(false)
        }
      } else {
        setShow404(true)
        clientMounted(false)
      }
    }
  }, [router?.query?.shardId])

  useEffect(() => {
    if (shard?.shard?.id) {
      changeRoute({
        collectionId: shard?.shard?.collection?.id || 0,
        shardId: shard?.shard?.id,
        sourceShardId: shard?.shard?.source_shard?.id,
      })
      clientMounted(true)
    }
  }, [shard?.shard?.id])

  if (show404) {
    return <PageNotFound404 />
  }

  return <NewShard />
}

export default Render
